import { render, staticRenderFns } from "./EdsFileKey.vue?vue&type=template&id=3b93b431&scoped=true&"
import script from "./EdsFileKey.vue?vue&type=script&lang=js&"
export * from "./EdsFileKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b93b431",
  null
  
)

export default component.exports